import Swiper, { Autoplay, Lazy, EffectFade, Pagination } from "swiper";

Swiper.use([Autoplay, Lazy, EffectFade, Pagination]);

(() => {
	//
	const topHeroSwiper = new Swiper(".js-topHero", {
		simulateTouch: false,
		speed: 1000,
		loop: true,
		effect: "fade",
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});
})();
